import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=40cf2436&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=40cf2436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf2436",
  null
  
)

export default component.exports